import PropTypes from 'prop-types';

/**
 * @deprecated
 * We no longer use enums for props (so that we don't force the user to import the enum).
 * This enum will remain here for backwards compatibility purposes.
 */
var Variants;
(function (Variants) {
    Variants["PRIMARY"] = "primary";
    Variants["SECONDARY"] = "secondary";
})(Variants || (Variants = {}));
var propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    variant: PropTypes.oneOf(['primary', 'secondary']),
    headerHeight: PropTypes.number,
    rowCount: PropTypes.number.isRequired,
    rowGetter: PropTypes.func.isRequired,
    keyGetter: PropTypes.func.isRequired,
    rowHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
    isSelectable: PropTypes.bool,
    selectedKeys: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.string),
        PropTypes.arrayOf(PropTypes.number),
    ]),
    onSelectionChange: PropTypes.func,
    isCollapsible: PropTypes.bool,
    collapsibleContentHeight: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.func,
    ]),
    collapsibleContentGetter: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
    ]),
    customCollapseIconProps: PropTypes.shape({
        collapseIconName: PropTypes.string,
        unCollapseIconName: PropTypes.string,
        size: PropTypes.number,
        buttonProps: PropTypes.object,
    }),
    collapsibleColumnCellRenderer: PropTypes.func,
    nonCollapsibleRowIndexes: PropTypes.arrayOf(PropTypes.number),
    expandedRowKeys: PropTypes.arrayOf(PropTypes.number),
    onCollapsibleContentChange: PropTypes.func,
    isRowClickable: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    customRowRenderer: PropTypes.func,
    hasError: PropTypes.bool,
    collapsibleRowClassName: PropTypes.string,
};
var defaultProps = {
    /**
     * We need to add a default width and height for test envs only,
     * that's because the autosizer cannot auto-size when there's no DOM!
     * Therefore no rows of the table would be rendered.
     */
    width: process.env.NODE_ENV === 'test' ? 20000 : undefined,
    height: process.env.NODE_ENV === 'test' ? 20000 : undefined,
    rowHeight: 54,
    headerHeight: 54,
    isSelectable: false,
    isCollapsible: false,
    selectedKeys: [],
    variant: 'primary',
    hasError: false,
    collapsibleRowClassName: '',
};

export { Variants, defaultProps, propTypes };
